import { ItineraryVersionPauseInterval } from 'core/graphql/types';
import { format, parseISO } from 'date-fns';

export interface ItineraryPauseIntervalProps {
  item: ItineraryVersionPauseInterval;
}

const ItineraryPauseInterval = ({ item }: ItineraryPauseIntervalProps) => {
  const startTime = format(parseISO(item?.startTime), 'HH:mm');
  const endTime = format(parseISO(item?.endTime), 'HH:mm');
  return (
    <div className="mt-2 w-full rounded bg-muted-white p-1 text-center dark:bg-design-secondary-black">
      {`${startTime} - ${endTime}`}
    </div>
  );
};

export default ItineraryPauseInterval;
